// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__37_On","title":"InfoRow_title__1yPj6"};